import { Suspense, lazy, ElementType } from 'react';
// components
import LoadingScreen from '../components/loading-screen';

// ----------------------------------------------------------------------

const Loadable = (Component: ElementType) => (props: any) =>
  (
    <Suspense fallback={<LoadingScreen />}>
      <Component {...props} />
    </Suspense>
  );

// ----------------------------------------------------------------------

// AUTH
export const LoginPage = Loadable(lazy(() => import('../pages/auth/OobSignInPage')));
export const LogOutPage = Loadable(lazy(() => import('../pages/LogOutPage')));
export const OobActionLandingPage = Loadable(
  lazy(() => import('../pages/auth/OobActionLandingPage'))
);
export const NotVerifiedPage = Loadable(lazy(() => import('../pages/auth/NotVerifiedPage')));
export const VerifiedPage = Loadable(lazy(() => import('../pages/auth/VerifiedPage')));

// DASHBOARD
export const DashboardPage = Loadable(lazy(() => import('../pages/dashboard/DashboardPage')));

// LISTINGS
export const ListingListPage = Loadable(lazy(() => import('../pages/listings/ListingListPage')));
export const ListingDetailsPage = Loadable(
  lazy(() => import('../pages/listings/ListingDetailsPage'))
);

// RESERVATIONS
export const ReservationListPage = Loadable(
  lazy(() => import('../pages/reservations/ReservationListPage'))
);
export const ReservationEditPage = Loadable(
  lazy(() => import('../pages/reservations/ReservationEditPage'))
);
export const ReservationCreatePage = Loadable(
  lazy(() => import('../pages/reservations/ReservationCreatePage'))
);
export const ReservationCalendarPage = Loadable(
  lazy(() => import('../pages/reservations/ReservationCalendarPage'))
);
export const ReservationHeatMapPage = Loadable(
  lazy(() => import('../pages/reservations/ReservationHeatMapPage'))
);

// TIMESHARES
export const TimeshareListPage = Loadable(
  lazy(() => import('../pages/timeshares/TimeshareListPage'))
);
export const TimeshareDetailsPage = Loadable(
  lazy(() => import('../pages/timeshares/TimeshareDetailsPage'))
);
export const TimeshareCreatePage = Loadable(
  lazy(() => import('../pages/timeshares/TimeshareCreatePage'))
);

// STATEMENTS
export const StatementsPage = Loadable(lazy(() => import('../pages/statements')));

// REPORTS
export const OwnerReportPage = Loadable(lazy(() => import('../pages/reports/OwnerReportPage')));

// CASES
export const CasePage = Loadable(lazy(() => import('../pages/cases/CasePage')));

// NOTIFICATIONS
export const NotificationPage = Loadable(
  lazy(() => import('../pages/notifications/NotificationPage'))
);

// USERS (Admin)
export const UserListPage = Loadable(lazy(() => import('../pages/users/UserListPage')));
export const UserEmulatorPage = Loadable(lazy(() => import('../pages/users/UserEmulatorPage')));
export const UserCreatePage = Loadable(lazy(() => import('../pages/users/UserCreatePage')));
export const UserEditPage = Loadable(lazy(() => import('../pages/users/UserEditPage')));

// ACCOUNT
export const UserAccountPage = Loadable(lazy(() => import('../pages/account/UserAccountPage')));

// UTILITY PAGES
export const PermissionDeniedPage = Loadable(
  lazy(() => import('../pages/dashboard/PermissionDeniedPage'))
);
export const ErrorPage = Loadable(lazy(() => import('../pages/ErrorPage')));

// MAIN/PUBLIC PAGES
export const Page500 = Loadable(lazy(() => import('../pages/Page500')));
export const Page403 = Loadable(lazy(() => import('../pages/Page403')));
export const Page404 = Loadable(lazy(() => import('../pages/Page404')));
export const FaqsPage = Loadable(lazy(() => import('../pages/FaqsPage')));
export const ComingSoonPage = Loadable(lazy(() => import('../pages/ComingSoonPage')));
export const MaintenancePage = Loadable(lazy(() => import('../pages/MaintenancePage')));

// DEV/DEMO (only in development)
export const DemoNoticesPage = Loadable(
  lazy(() => import('../portalNotification/components/PortalNotificationBanner'))
);
export const BrandSelectorPage = Loadable(lazy(() => import('../pages/dev/BrandSelectorPage')));
